export default "__VITE_ASSET__l5lI56jF__"